import Client from "../client/ApiClient"

const login = (data) => {
  const payload = { ...data }
  if (payload.username && !payload.email) payload.email = payload.username
  return Client.post("auth/login/", payload)
}

const googleConfig = () => Client.get("auth/oauth/google/config/")
const googleLogin = (idToken) => Client.post("auth/oauth/google/", { id_token: idToken })
const me = () => Client.get("auth/me/")
const changePassword = (body) => Client.post("auth/change-password/", body)

const userRepository = {
  login,
  googleConfig,
  googleLogin,
  me,
  changePassword
}
export default userRepository
